module.exports = __webpack_public_path__ + "img/img10.d5dd38d6.png";